var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g6, _path18, _path19, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampaignsManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_88:319",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 63,
    height: 62
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32C49.1208 0 63 13.8792 63 31C63 48.1208 49.1208 62 32 62H0V0Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_88:319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.19276e-10 5.77802C0 2.58691 2.58691 0 5.77802 2.19461e-10L92.5731 3.51612e-09C94.2355 3.57926e-09 95.8174 0.716028 96.9144 1.96508L299.247 232.336C301.329 234.707 301.125 238.31 298.787 240.429L263.021 272.863L217.52 314.047C215.122 316.218 211.409 315.997 209.285 313.557L1.42003 74.7816C0.50437 73.7298 2.74691e-09 72.3823 2.69399e-09 70.9877L2.19276e-10 5.77802Z",
    fill: "#3388FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 10.2706C58 7.35972 60.3597 5 63.2706 5L134.57 5C136.089 5 137.533 5.65502 138.534 6.79721L305.93 197.848C307.823 200.009 307.637 203.288 305.511 205.221L276.177 231.886L238.8 265.797C236.611 267.783 233.218 267.582 231.28 265.35L59.2912 67.3113C58.4585 66.3525 58 65.1252 58 63.8553L58 10.2706Z",
    fill: "#7FB5FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_88:319",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 64,
    height: 62
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000488281 0H31.9995C49.1203 0 62.9995 13.8792 62.9995 31C62.9995 48.1208 49.1203 62 31.9995 62H-0.000488281V0Z",
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_88:319)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_88:319)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_88:319)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41089 41.0288V10.6306C8.41089 9.40441 9.25983 8.41431 10.3112 8.41431H44.6231C45.6688 8.41431 46.5178 9.40441 46.5178 10.6306V41.0288C46.5178 42.2484 45.6688 43.2451 44.6231 43.2451H10.3112C9.25983 43.2451 8.41089 42.2484 8.41089 41.0288Z",
    fill: "#DAEAFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_88:319",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 39,
    height: 32
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5179 39.5132V13.3299C46.5179 10.6151 44.3171 8.41431 41.6023 8.41431H10.2895C9.80104 8.41431 9.3671 8.64213 9.04386 8.97939C8.63641 9.40451 8.85343 10.0549 9.31726 10.4176L46.5179 39.5132Z",
    fill: "#3388FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_88:319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.41089 41.0288V10.6306C8.41089 9.40441 9.25983 8.41431 10.3112 8.41431H44.6231C45.6688 8.41431 46.5178 9.40441 46.5178 10.6306V41.0288C46.5178 42.2484 45.6688 43.2451 44.6231 43.2451H10.3112C9.25983 43.2451 8.41089 42.2484 8.41089 41.0288Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_88:319",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 22,
    width: 44,
    height: 30
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4555 38.7443V35.2084C28.4895 35.2084 28.5235 35.2019 28.5576 35.2019H29.3686C30.7127 35.2019 31.8072 36.4637 31.8072 38.0214V41.8398L32.5672 42.7205V37.9556C32.5672 37.8833 32.5729 37.811 32.5785 37.7387V24.0553C32.5785 22.9972 33.3158 22.1428 34.2289 22.1428C35.142 22.1428 35.8792 22.9972 35.8792 24.0553V33.1316C36.1401 33.0659 36.401 33.0199 36.6732 33.0067V29.9572C36.6732 28.8991 37.4105 28.0447 38.3236 28.0447C39.231 28.0447 39.9739 28.8991 39.9739 29.9572V32.9936H40.7679V31.6989C40.7679 30.6473 41.5109 29.7863 42.4183 29.7863C43.3313 29.7863 44.0686 30.6407 44.0686 31.6989V33.0067C44.3465 33.0265 44.6131 33.0725 44.8739 33.1513C45.0781 32.3627 45.7076 31.7843 46.4506 31.7843C47.3636 31.7843 48.1009 32.6387 48.1009 33.6968V37.9556V42.7074V46.0263C48.1009 47.6957 47.392 49.1679 46.3031 50.0683L35.7204 50.8044C35.0285 50.5875 34.4047 50.1734 33.9 49.6148L28.4385 43.4237V38.7377C28.4441 38.7377 28.4498 38.7377 28.4555 38.7443Z",
    fill: "#EDF4FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34546 33.8459L6.36062 31.1907H6.33227L7.3928 28.483L8.33424 26.0118L8.35693 26.025L8.37961 25.9658L15.1171 26.0841C15.1171 26.1367 15.1228 26.1893 15.1228 26.2484L15.1058 27.5497C15.0774 29.7054 13.5462 31.4208 11.686 31.3879L10.9487 31.3616L9.90519 34.9895C12.0206 36.7969 13.4498 40.2539 13.4498 44.2169C13.4498 47.2599 12.6047 50.0005 11.255 51.9327H5.36814V33.8591L5.34546 33.8459Z",
    fill: "#EDF4FC"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_88:319)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.0283,
    y: 19,
    width: 99.8038,
    height: 78.6501,
    rx: 4.93299,
    fill: "#AFD0FE"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7637 12.3999H11.8364V39.4142H42.7637V12.3999Z",
    fill: "#5C656F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_88:319",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 12,
    width: 32,
    height: 28
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7637 12.4001H11.8364V39.4144H42.7637V12.4001Z",
    fill: "#D8DDE1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_88:319)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_88:319)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_88:319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3813 47.5992H16.4099C16.0565 47.5992 15.7703 47.245 15.7703 46.8076V15.4429C15.7703 15.0056 16.0565 14.6514 16.4099 14.6514H38.3813C38.7347 14.6514 39.021 15.0056 39.021 15.4429V46.8076C39.021 47.245 38.7347 47.5992 38.3813 47.5992Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.3813 14.6514H16.4099C16.0565 14.6514 15.7703 15.0056 15.7703 15.4429V20.6623H39.021V15.4429C39.021 15.0056 38.7347 14.6514 38.3813 14.6514Z",
    fill: "#D8DDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0365 31.7605H33.9819V32.661H37.0365V31.7605Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0365 34.9121H33.9819V35.8126H37.0365V34.9121Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0366 17.3528H30.5457V18.2533H37.0366V17.3528Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0366 22.7556H30.5457V23.6561H37.0366V22.7556Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4365 22.7556H17.9456V23.6561H24.4365V22.7556Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4365 25.9072H17.9456V26.8077H24.4365V25.9072Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3092 31.7605H17.9456V32.661H31.3092V31.7605Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3456 34.9121H17.9456V35.8126H26.3456V34.9121Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0365 38.0637H33.9819V38.9642H37.0365V38.0637Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6365 38.0637H17.9456V38.9642H28.6365V38.0637Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M38.3811 47.0591C38.7345 47.0591 39.0208 46.7107 39.0208 46.2805V15.43C39.0208 14.9998 38.7345 14.6514 38.3811 14.6514L27.395 14.6514V47.0591C31.0571 47.0591 34.7191 47.0591 38.3811 47.0591Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_88:319",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 22,
    width: 44,
    height: 30
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4555 38.7443V35.2084C28.4895 35.2084 28.5235 35.2019 28.5576 35.2019H29.3686C30.7127 35.2019 31.8072 36.4637 31.8072 38.0214V41.8398L32.5672 42.7205V37.9556C32.5672 37.8833 32.5729 37.811 32.5785 37.7387V24.0553C32.5785 22.9972 33.3158 22.1428 34.2289 22.1428C35.142 22.1428 35.8792 22.9972 35.8792 24.0553V33.1316C36.1401 33.0659 36.401 33.0199 36.6732 33.0067V29.9572C36.6732 28.8991 37.4105 28.0447 38.3236 28.0447C39.231 28.0447 39.9739 28.8991 39.9739 29.9572V32.9936H40.7679V31.6989C40.7679 30.6473 41.5109 29.7863 42.4183 29.7863C43.3313 29.7863 44.0686 30.6407 44.0686 31.6989V33.0067C44.3465 33.0265 44.6131 33.0725 44.8739 33.1513C45.0781 32.3627 45.7076 31.7843 46.4506 31.7843C47.3636 31.7843 48.1009 32.6387 48.1009 33.6968V37.9556V42.7074V46.0263C48.1009 47.6957 47.392 49.1679 46.3031 50.0683L35.7204 50.8044C35.0285 50.5875 34.4047 50.1734 33.9 49.6148L28.4385 43.4237V38.7377C28.4441 38.7377 28.4498 38.7377 28.4555 38.7443Z",
    fill: "#EDF4FC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34546 33.8459L6.36062 31.1907H6.33227L7.3928 28.483L8.33424 26.0118L8.35693 26.025L8.37961 25.9658L15.1171 26.0841C15.1171 26.1367 15.1228 26.1893 15.1228 26.2484L15.1058 27.5497C15.0774 29.7054 13.5462 31.4208 11.686 31.3879L10.9487 31.3616L9.90519 34.9895C12.0206 36.7969 13.4498 40.2539 13.4498 44.2169C13.4498 47.2599 12.6047 50.0005 11.255 51.9327H5.36814V33.8591L5.34546 33.8459Z",
    fill: "#EDF4FC"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_88:319)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 31,
    y: 28,
    width: 81,
    height: 61,
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.2
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5179 39.5132V13.3299C46.5179 10.6151 44.3171 8.41431 41.6023 8.41431H10.2964C9.48442 8.41431 8.81352 9.03628 8.54517 9.81376L46.5179 39.5132Z",
    fill: "white"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1452 43.2451H7.3374V72.4781H19.1452V43.2451Z",
    fill: "#DEC1AE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2228 40.5065V36.9706C31.2569 36.9706 31.2909 36.9641 31.3249 36.9641H32.1359C33.48 36.9641 34.5746 38.2259 34.5746 39.7836V43.602L35.3345 44.4827V39.7178C35.3345 39.6455 35.3402 39.5732 35.3459 39.5009V25.8176C35.3459 24.7594 36.0831 23.905 36.9962 23.905C37.9093 23.905 38.6466 24.7594 38.6466 25.8176V34.8938C38.9075 34.8281 39.1683 34.7821 39.4406 34.7689V31.7194C39.4406 30.6613 40.1778 29.8069 41.0909 29.8069C41.9983 29.8069 42.7413 30.6613 42.7413 31.7194V34.7558H43.5352V33.4611C43.5352 32.4095 44.2782 31.5485 45.1856 31.5485C46.0987 31.5485 46.8359 32.4029 46.8359 33.4611V34.7689C47.1138 34.7887 47.3804 34.8347 47.6413 34.9135C47.8454 34.1249 48.475 33.5465 49.2179 33.5465C50.131 33.5465 50.8683 34.4009 50.8683 35.459V39.7178V44.4696V47.7885C50.8683 49.4579 50.1593 50.9301 49.0704 51.8305V95.7265H38.4878V52.5666C37.7959 52.3497 37.172 51.9356 36.6673 51.377L31.2058 45.1859V40.4999C31.2115 40.4999 31.2172 40.4999 31.2228 40.5065Z",
    fill: "#DEC1AE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33747 35.6892L8.35949 33.034H8.33094L9.39864 30.3262L10.3464 27.8551L10.3693 27.8682L10.3921 27.8091L17.1751 27.9274C17.1751 27.98 17.1808 28.0325 17.1808 28.0917L17.1637 29.393C17.1352 31.5487 15.5936 33.264 13.7208 33.2312L12.9786 33.2049L11.928 36.8328C14.0577 38.6401 15.4965 42.0971 15.4965 46.0602C15.4965 49.1031 14.6002 53.425 13.2413 55.3573H7.3374L7.33747 35.6892Z",
    fill: "#EFD0BB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3637 55.3572H6.8728V133.743H13.3637V55.3572Z",
    fill: "#3388FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8547 55.3572H13.3638V133.743H19.8547V55.3572Z",
    fill: "#1760CE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_88:319",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 24,
    width: 10,
    height: 81
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3846 24.7988H43.8342V104.81H52.3846V24.7988Z",
    fill: "#3388FF"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_88:319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0555 40.5065V36.9706C31.0898 36.9706 31.1241 36.9641 31.1584 36.9641H31.9758C33.3305 36.9641 34.4338 38.2259 34.4338 39.7836V43.602L35.1998 44.4827V39.7178C35.1998 39.6455 35.2055 39.5732 35.2112 39.5009V25.8176C35.2112 24.7594 35.9543 23.905 36.8746 23.905C37.7949 23.905 38.5381 24.7594 38.5381 25.8176V34.8938C38.801 34.8281 39.0639 34.7821 39.3383 34.7689V31.7194C39.3383 30.6613 40.0814 29.8069 41.0018 29.8069C41.9164 29.8069 42.6652 30.6613 42.6652 31.7194V34.7558H43.4655V33.4611C43.4655 32.4095 44.2143 31.5485 45.1289 31.5485C46.0492 31.5485 46.7923 32.4029 46.7923 33.4611V34.7689C47.0724 34.7887 47.3411 34.8347 47.604 34.9135C47.8098 34.1249 48.4443 33.5465 49.1931 33.5465C50.1135 33.5465 50.8566 34.4009 50.8566 35.459V39.7178V44.4696V47.7885C50.8566 49.4579 50.142 50.9301 49.0445 51.8305V95.7265H38.378V52.5666C37.6806 52.3497 37.0518 51.9356 36.5431 51.377L31.0383 45.1859V40.4999C31.044 40.4999 31.0498 40.4999 31.0555 40.5065Z",
    fill: "#EFD0BB"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9091 55.3572H37.8V133.743H43.9091V55.3572Z",
    fill: "#1760CE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4001 55.3572H43.9092V133.743H50.4001V55.3572Z",
    fill: "#3388FF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_88:319",
    x: -3.1272,
    y: 8.41431,
    width: 53.9954,
    height: 132.329,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_88:319"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_88:319",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_88:319",
    x: 2.8728,
    y: 8.41431,
    width: 51.9954,
    height: 133.329,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_88:319"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_88:319",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_88:319",
    x: 15.7703,
    y: 14.6514,
    width: 23.2507,
    height: 37.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.17722
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_88:319"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_88:319",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_88:319",
    x: 13.7703,
    y: 14.6514,
    width: 25.2507,
    height: 34.9478,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_88:319"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_88:319",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignsManagement);
export default __webpack_public_path__ + "static/media/campaigns_management.64e1ae3f.svg";
export { ForwardRef as ReactComponent };